import styled from 'styled-components'

export const OpenChatButton = styled.button`
  position: fixed;
  bottom: 0;
  right: 40px;
  width: 320px;
  height: 45px;
  padding-left: 16px;
  padding-right: 0.75rem;

  display: flex;
  justify-content: space-between;
  align-items: center;

  background: #fff;
  border: 0.8px solid #dce0e8;
  cursor: pointer;
  border-radius: 16px 16px 0px 0px;
  box-shadow: 0px 0px 16px 0px #2b3d4514;

  z-index: 10000;

  * {
    pointer-events: none;
  }
`
